module.exports = __webpack_public_path__ + "img/icon-pdf.4a6e5887.svg";